import React, { useRef } from 'react';

import styled from 'styled-components';

import useInfiniteScroll from 'utils/hooks/useInfiniteScroll';

import ReviewItem from './ReviewItem';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  overflow-y: auto;
  gap: 20px;
`;

const LoadMoreTrigger = styled.div`
  min-height: 1px;
`;

const LoadingState = styled.div`
  color: var(--text-secondary);
  font-size: 12px;
  text-align: center;
`;

interface Props {
  data: any;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  onLoadMore?: () => void;
}

export const Reviews = ({ data, hasNextPage = false, isFetchingNextPage = false, onLoadMore }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const loadMoreTriggerRef = useRef<HTMLDivElement>(null);

  useInfiniteScroll({
    rootRef: containerRef,
    triggerRef: loadMoreTriggerRef,
    hasNextPage,
    isFetchingNextPage,
    onLoadMore,
  });

  return (
    <Container ref={containerRef} className="mini-scroll">
      {data?.map((item: any) => (
        <ReviewItem key={item.id} item={item} />
      ))}
      {hasNextPage && <LoadMoreTrigger ref={loadMoreTriggerRef} />}
      {isFetchingNextPage && <LoadingState>Loading more reviews...</LoadingState>}
    </Container>
  );
};

export default Reviews;
